import { EventEmitter } from "events"
import dispatcher from "../dispatcher"
import moment, { Moment } from "moment"
import * as utils from "../helpers/utils"

class UserTimecardStore extends EventEmitter {
    referenceDate: Date | string | Moment
    fetchingDates: boolean
    localStorageKey = "EmpTimecardRefDate"
    constructor() {
        super()
        this.setMaxListeners(0)
        const storedEmpTimecardRefDate = utils.getCookie(this.localStorageKey)
        this.referenceDate = storedEmpTimecardRefDate ? storedEmpTimecardRefDate : moment()
    }

    getReferenceDate() {
        return this.referenceDate
    }

    receiveReferenceDate(date) {
        localStorage.setItem(`findd_${this.localStorageKey}`, date)
        this.referenceDate = date
    }

    handleActions(action) {
        switch (action.type) {
            case "RECEIVE_TIMECARD_REFERENCE_DATE": {
                this.receiveReferenceDate(action.data)
            }
        }
    }
}

const userTimecardStore = new UserTimecardStore()
dispatcher.register(userTimecardStore.handleActions.bind(userTimecardStore))
export default userTimecardStore
